<template>
  <div :class="['tooltip-container', 
    {
    medium: size === 'medium',
    large: size === 'large',
    center: position === 'center',
    tr: position === 'tr',
    right: position === 'right',
    bc: position === 'bc'
    }
  ]" ref="tooltip-container">
    <div class="connecter-part"></div>
    <div class="tooltip">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Tooltip',
    props: {
      position: String,
      size: String
    },
    methods: {
      tooltipPosition(event) {
        console.log(event);
      }
    },
    mounted() {
      this.$refs['tooltip-container'].parentElement.addEventListener('mouseenter', () => {
        const element = this.$refs['tooltip-container']
        const rect = element.getBoundingClientRect()
        
        if (rect.left < 0) {
          element.classList.add('exceeds-left-position')
        }
      })
    }
  }
</script>

<style lang="scss">
.icon-question-mark,
.task-portraits__portrait,
.tag-item,
.label {
  position: relative;
  cursor: pointer;
  &:hover {
      color: var(--primary-text);
      .tooltip-container {
          display: block;
      } 
  }
}

.tooltip-container {
  display: none;
  position: absolute;
  z-index: 99;
  top: 20px;
  right: 0;
  width: max-content;

  .connecter-part {
    width: 70%;
    height: 20px;
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
  }

  .tooltip {
    padding: 8px;
    border-radius: 10px;
    background: var(--primary-bg);
    border: 0.5px solid var(--outline);
    backdrop-filter: blur(6px);
    font-size: 13px;
    font-weight: 300;
    text-align: left;
    line-height: 17px;
    width: max-content;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    &__edit {
      display: flex;
      justify-content: center;
      align-items: center;
      
      a {
        display: block;
        margin-top: 3px;
        margin-left: 3px;
      }
    }


    &__blue-text {
        color: var(--accent);
    }

    &__list {
        font-size: 13px;
        font-weight: 300;
        margin: 10px 0;
    }
    &__item {
        margin: 0;
        line-height: 19px;
    }
    &__li {
      list-style: none;
    }

    &__img {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      object-fit: cover;
      margin-bottom: 8px;
      margin: 0 auto;
      background-color: #fff;
      color: black;
      font-size: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__label {
      font-weight: 400;
      line-height: 150%;
      padding-left: 4px;
    }
    &__paragraph {
      font-weight: 300;
      line-height: 150%;
      background: rgba(115, 115, 115, 0.18);
      border-radius: 4px;
      padding: 2px 4px;
      word-break: break-word;
      min-height: 23.5px;
    }
    &__flex {
      display: flex;
    }

    ul {
      padding-inline-start: 10px;

      li::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 4px;
        margin-right: 10px;
        margin-bottom: 2px;
        border-radius: 50%;
        background: #CFCFCF;
      }
    }
  }

  &.center {
    top: 43px;
    left: 50%;
    transform: translateX(-50%);
  }
  &.left {
    left: 0;
    right: auto;
  }
  &.right {
    top: 30px;
    right: 0;
    left: auto;
  }

  &.tr {
    right: auto;
    left: 20px;
    top: -2px;
  }

  &.bc {
    bottom: 30px;
    top: auto;
    right: 0;
    left: auto;
  }

  &.medium > * {
    max-width: 141px;
  }

  &.large > * {
    width: 183.3px;
    padding: 15px !important;
    .tooltip {
      &__img {
        height: 83px;
        width: 83px;
      }
    }
  }

  &.right-bottom {
    top: auto;
    right: auto;
    bottom: 0;
    left: 10px;
  }

  &.exceeds-left-position {
    left: 0;
    transform: translateX(0);
  }
}


.task-portraits__portrait {
  .tooltip {
    max-width: 141px;
  }
}

.max-wth {
  width: 130px;
}
</style>